"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _panel = _interopRequireDefault(require("../panel"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _ColorSelector = _interopRequireDefault(require("../community-header/ColorSelector"));

var _footerPanel = require("./footerPanel");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _Loader = _interopRequireDefault(require("../ui-components/Loader"));

var _api = require("../../utils/api");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TRIGGER_TYPES = ['button', 'floating'];
var TRIGGER_POSITIONS = ['left', 'right'];
var USER_AVATAR_SHAPES = ['circle', 'square', 'rounded-square'];

var mapStateToWidgetConfig = function mapStateToWidgetConfig(state) {
  return {
    trigger_text: state.triggerText,
    trigger_color: state.triggerColor,
    brand_color: state.triggerBgColor,
    trigger_type: state.triggerType,
    position: state.triggerPosition,
    header_title: state.headerTitle,
    header_color: state.headerTextColor,
    header_background: state.headerBgColor,
    header_shadow: state.headerShowShadow,
    card_user_avatar_radius: state.cardUserAvatarShape,
    card_title_color: state.cardTitleColor,
    card_metadata_color: state.cardMetadataColor,
    card_border_color: state.cardBorderColor,
    footer_configuration: state.footerConfiguration,
    powered_by_enabled: true
  };
};

var EmbeddableWidgetConfigurator = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmbeddableWidgetConfigurator, _Component);

  var _super = _createSuper(EmbeddableWidgetConfigurator);

  function EmbeddableWidgetConfigurator(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmbeddableWidgetConfigurator);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "script", void 0);
    _this.script = null; // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      isSuccess: false,
      isError: false,
      isLoading: false,
      triggerText: 'Community Help',
      triggerColor: '#ffffff',
      triggerBgColor: '#1dadf5',
      triggerType: 'button',
      triggerPosition: 'right',
      headerTitle: '#Community',
      headerTextColor: '#DE8E8E',
      headerBgColor: '#1DADF5',
      headerShowShadow: true,
      cardUserAvatarShape: 'circle',
      cardTitleColor: '#1A1A1A',
      cardMetadataColor: '#A7AEB5',
      cardBorderColor: '#f2f2f2',
      footerConfiguration: {
        title: '',
        links: []
      }
    };
    return _this;
  }

  (0, _createClass2.default)(EmbeddableWidgetConfigurator, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context.prev = 1;
                _context.t0 = this;
                _context.next = 5;
                return (0, _api.getEmbeddableWidgetConfig)();

              case 5:
                _context.t1 = _context.sent;

                _context.t0.setStateFromBackend.call(_context.t0, _context.t1);

                this.setState({
                  isError: false,
                  isSuccess: true
                });
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t2 = _context["catch"](1);
                this.setState({
                  isError: true,
                  isSuccess: false
                });

              case 13:
                _context.prev = 13;
                this.setState({
                  isLoading: false
                });
                return _context.finish(13);

              case 16:
                window.addEventListener('insided:conversational:loaded', function () {
                  _this2.setState({
                    isSuccess: true,
                    isLoading: false
                  });
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10, 13, 16]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setStateFromBackend",
    value: function setStateFromBackend(data) {
      this.setState({
        triggerText: data.trigger_text,
        triggerColor: data.trigger_color,
        triggerBgColor: data.brand_color,
        triggerType: data.trigger_type,
        triggerPosition: data.position,
        headerTitle: data.header_title,
        headerTextColor: data.header_color,
        headerBgColor: data.header_background,
        headerShowShadow: data.header_shadow,
        cardUserAvatarShape: data.card_user_avatar_radius,
        cardTitleColor: data.card_title_color,
        cardMetadataColor: data.card_metadata_color,
        cardBorderColor: data.card_border_color,
        footerConfiguration: JSON.parse(data.footer_configuration)
      });
    }
  }, {
    key: "preview",
    value: function () {
      var _preview = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _window$inSided;

        var bundleSrc, _this$script$parentNo;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ((_window$inSided = window.inSided) !== null && _window$inSided !== void 0 && _window$inSided.conversational) {
                  window.inSided.conversational.destroy();
                }

                this.setState({
                  isError: false,
                  isSuccess: false,
                  isLoading: true
                });
                _context2.prev = 2;
                _context2.next = 5;
                return (0, _api.getEmbeddableWidgetBundle)(mapStateToWidgetConfig(this.state));

              case 5:
                bundleSrc = _context2.sent;

                if (this.script) {
                  (_this$script$parentNo = this.script.parentNode) === null || _this$script$parentNo === void 0 ? void 0 : _this$script$parentNo.removeChild(this.script);
                }

                this.script = document.createElement('script');
                this.script.src = bundleSrc;
                this.script.async = true;
                document.body.appendChild(this.script);
                this.setState({
                  isSuccess: true,
                  isError: false
                });
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](2);
                this.setState({
                  isError: true,
                  isSuccess: false
                });

              case 17:
                _context2.prev = 17;
                this.setState({
                  isLoading: false
                });
                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 14, 17, 20]]);
      }));

      function preview() {
        return _preview.apply(this, arguments);
      }

      return preview;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var newConfig;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  isError: false,
                  isSuccess: false,
                  isLoading: true
                });
                newConfig = mapStateToWidgetConfig(this.state);
                _context3.prev = 2;
                _context3.next = 5;
                return (0, _api.updateEmbeddableWidgetConfig)(newConfig);

              case 5:
                this.setState({
                  isSuccess: true,
                  isError: false
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                this.setState({
                  isError: true,
                  isSuccess: false
                });

              case 11:
                _context3.prev = 11;
                this.setState({
                  isLoading: false
                });
                return _context3.finish(11);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8, 11, 14]]);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "normalizeTriggerTypes",
    value: function normalizeTriggerTypes() {
      var _this3 = this;

      return TRIGGER_TYPES.map(function (type) {
        return {
          title: type,
          value: type,
          onClick: function onClick() {
            return _this3.setState({
              triggerType: type
            });
          }
        };
      });
    }
  }, {
    key: "normalizeTriggerPositions",
    value: function normalizeTriggerPositions() {
      var _this4 = this;

      return TRIGGER_POSITIONS.map(function (position) {
        return {
          title: position,
          value: position,
          onClick: function onClick() {
            return _this4.setState({
              triggerPosition: position
            });
          }
        };
      });
    }
  }, {
    key: "normalizeAvatarShapes",
    value: function normalizeAvatarShapes() {
      var _this5 = this;

      return USER_AVATAR_SHAPES.map(function (shape) {
        return {
          title: shape,
          value: shape,
          onClick: function onClick() {
            return _this5.setState({
              cardUserAvatarShape: shape
            });
          }
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this,
          _footerConfiguration$,
          _footerConfiguration$2;

      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          triggerType = _this$state.triggerType,
          triggerPosition = _this$state.triggerPosition,
          triggerText = _this$state.triggerText,
          triggerColor = _this$state.triggerColor,
          triggerBgColor = _this$state.triggerBgColor,
          headerTitle = _this$state.headerTitle,
          headerTextColor = _this$state.headerTextColor,
          headerBgColor = _this$state.headerBgColor,
          headerShowShadow = _this$state.headerShowShadow,
          cardUserAvatarShape = _this$state.cardUserAvatarShape,
          cardTitleColor = _this$state.cardTitleColor,
          cardMetadataColor = _this$state.cardMetadataColor,
          cardBorderColor = _this$state.cardBorderColor,
          footerConfiguration = _this$state.footerConfiguration,
          isSuccess = _this$state.isSuccess,
          isError = _this$state.isError;
      return (0, _preact.h)("div", {
        className: "conversational-widget-new"
      }, (0, _preact.h)(_header.default, {
        title: "Customization",
        saveCallback: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this6.save();

                case 2:
                  return _context4.abrupt("return", _context4.sent);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })),
        customButtons: [{
          variant: 'primary',
          title: 'Preview',
          action: function () {
            var _action = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
              return _regenerator.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return _this6.preview();

                    case 2:
                      return _context5.abrupt("return", _context5.sent);

                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }));

            function action() {
              return _action.apply(this, arguments);
            }

            return action;
          }(),
          customClass: 'conversational_preview-button'
        }]
      }), isSuccess && (0, _preact.h)(_AlertComponent.default, {
        messageType: "success",
        isVisibleFor: 3000
      }), isError && (0, _preact.h)(_AlertComponent.default, {
        messageType: "error",
        isVisibleFor: 3000
      }), isLoading && (0, _preact.h)(_Loader.default, null), (0, _preact.h)(_panel.default, {
        title: "Trigger"
      }, (0, _preact.h)("label", {
        className: "trigger-label"
      }, "Applicable for embeddable widget only."), (0, _preact.h)("div", {
        className: "trigger_wrapper-dropdowns form-group"
      }, (0, _preact.h)("div", null, (0, _preact.h)("label", null, "Trigger type"), (0, _preact.h)(_DropdownControl.default, {
        align: "adjust",
        triggerClass: "trigger_dropdown",
        items: this.normalizeTriggerTypes(),
        trigger: (0, _preact.h)(_Button.default, {
          icon: "arrowDropdown",
          title: triggerType,
          className: "half-dropdowns trigger-type"
        })
      })), (0, _preact.h)("div", null, (0, _preact.h)("label", null, "Trigger position"), (0, _preact.h)(_DropdownControl.default, {
        align: "adjust",
        triggerClass: "trigger_dropdown",
        items: this.normalizeTriggerPositions(),
        trigger: (0, _preact.h)(_Button.default, {
          icon: "arrowDropdown",
          title: triggerPosition,
          className: "half-dropdowns trigger-position"
        })
      }))), (0, _preact.h)(_InputGroup.default, {
        title: "Trigger text",
        type: "text",
        onChange: function onChange(e) {
          _this6.setState({
            triggerText: e.target.value
          });
        },
        value: triggerText
      }), (0, _preact.h)("div", {
        className: "wrapper-trigger_colors"
      }, (0, _preact.h)(_ColorSelector.default, {
        title: "Text Color",
        className: "text_color",
        selectedColor: triggerColor,
        onCallback: function onCallback(color) {
          return _this6.setState({
            triggerColor: color
          });
        }
      }), (0, _preact.h)(_ColorSelector.default, {
        title: "Background Color",
        className: "background_color",
        selectedColor: triggerBgColor,
        onCallback: function onCallback(color) {
          return _this6.setState({
            triggerBgColor: color
          });
        }
      }))), (0, _preact.h)(_panel.default, {
        title: "Header"
      }, (0, _preact.h)("label", {
        className: "trigger-label"
      }, "Applicable for embeddable widget only."), (0, _preact.h)(_InputGroup.default, {
        title: "Title on home page",
        type: "text",
        onChange: function onChange(e) {
          _this6.setState({
            headerTitle: e.target.value
          });
        },
        value: headerTitle
      }), (0, _preact.h)("div", {
        className: "wrapper-trigger_colors"
      }, (0, _preact.h)(_ColorSelector.default, {
        title: "Text Color",
        className: "text_color",
        selectedColor: headerTextColor,
        onCallback: function onCallback(color) {
          return _this6.setState({
            headerTextColor: color
          });
        }
      }), (0, _preact.h)(_ColorSelector.default, {
        title: "Background Color",
        className: "background_color",
        selectedColor: headerBgColor,
        onCallback: function onCallback(color) {
          return _this6.setState({
            headerBgColor: color
          });
        }
      })), (0, _preact.h)("div", {
        className: "header_shadow_checkbox"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Show a shadow below widget header",
        type: "checkbox",
        checked: headerShowShadow,
        onChangeCheckbox: function onChangeCheckbox() {
          _this6.setState(function (state) {
            return {
              headerShowShadow: !state.headerShowShadow
            };
          });
        },
        value: "preview"
      }))), (0, _preact.h)(_panel.default, {
        title: "Topic card"
      }, (0, _preact.h)("label", {
        className: "trigger-label"
      }, "Applicable for both embeddable widget and in-page widget."), (0, _preact.h)("div", {
        className: "wrapper-trigger_colors"
      }, (0, _preact.h)(_ColorSelector.default, {
        title: "Title Text Color",
        className: "text_color",
        selectedColor: cardTitleColor,
        onCallback: function onCallback(color) {
          return _this6.setState({
            cardTitleColor: color
          });
        }
      }), (0, _preact.h)(_ColorSelector.default, {
        title: "Metadata Text Color",
        className: "background_color",
        selectedColor: cardMetadataColor,
        onCallback: function onCallback(color) {
          return _this6.setState({
            cardMetadataColor: color
          });
        }
      })), (0, _preact.h)("div", {
        className: "wrapper-trigger_colors"
      }, (0, _preact.h)(_ColorSelector.default, {
        title: "Border Color",
        className: "text_color",
        selectedColor: cardBorderColor,
        onCallback: function onCallback(color) {
          return _this6.setState({
            cardBorderColor: color
          });
        }
      }), (0, _preact.h)("div", {
        className: "topic-card_user-avatar-shapes"
      }, (0, _preact.h)("label", null, "User Avatar Shape"), (0, _preact.h)(_DropdownControl.default, {
        align: "adjust",
        items: this.normalizeAvatarShapes(),
        trigger: (0, _preact.h)(_Button.default, {
          icon: "arrowDropdown",
          title: cardUserAvatarShape,
          className: "half-dropdowns"
        })
      })))), (0, _preact.h)(_footerPanel.FooterPanel, {
        footerTitle: (_footerConfiguration$ = footerConfiguration.title) !== null && _footerConfiguration$ !== void 0 ? _footerConfiguration$ : '',
        links: (_footerConfiguration$2 = footerConfiguration.links) !== null && _footerConfiguration$2 !== void 0 ? _footerConfiguration$2 : [],
        onTitleChanged: function onTitleChanged(title) {
          var currentFooterConfiguration = _this6.state.footerConfiguration;
          currentFooterConfiguration.title = title;

          _this6.setState({
            footerConfiguration: currentFooterConfiguration
          });
        },
        onAddLink: function onAddLink(title, url) {
          if (title && url) {
            var _currentFooterConfigu;

            var currentFooterConfiguration = _this6.state.footerConfiguration;
            currentFooterConfiguration.links = [].concat((0, _toConsumableArray2.default)((_currentFooterConfigu = currentFooterConfiguration.links) !== null && _currentFooterConfigu !== void 0 ? _currentFooterConfigu : []), [{
              title: title,
              url: url
            }]);

            _this6.setState({
              footerConfiguration: currentFooterConfiguration
            });
          }
        },
        onRemoveLink: function onRemoveLink(idx) {
          var _currentFooterConfigu2;

          var currentFooterConfiguration = _this6.state.footerConfiguration;
          var links = (_currentFooterConfigu2 = currentFooterConfiguration.links) !== null && _currentFooterConfigu2 !== void 0 ? _currentFooterConfigu2 : [];
          links.splice(idx, 1);
          currentFooterConfiguration.links = links;

          _this6.setState({
            footerConfiguration: currentFooterConfiguration
          });
        },
        onLinkChanged: function onLinkChanged(idx, newTitle, newUrl) {
          var _this6$state$footerCo;

          var newLinks = (0, _toConsumableArray2.default)((_this6$state$footerCo = _this6.state.footerConfiguration.links) !== null && _this6$state$footerCo !== void 0 ? _this6$state$footerCo : []);
          var currentFooterConfiguration = _this6.state.footerConfiguration;
          newLinks[idx].title = newTitle;
          newLinks[idx].url = newUrl;
          currentFooterConfiguration.links = newLinks;

          _this6.setState({
            footerConfiguration: currentFooterConfiguration
          });
        }
      }));
    }
  }]);
  return EmbeddableWidgetConfigurator;
}(_preact.Component);

var _default = EmbeddableWidgetConfigurator;
exports.default = _default;